import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesCustomFieldsEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-custom-fields-edit',
	path: '/secure/admin/EditCustomField(\\w*)!default.jspa',
};
